import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { ToastrService } from '../_services/toastr.service';
import { AppComponent } from '../app.component';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  model: any = {};
  forgotPasswordStatus = false;
  forgotPasswordForm: FormGroup;
  appName: any;
  copyright: any;

  // tslint:disable-next-line: max-line-length
  constructor(private authService: AuthService, private fb: FormBuilder, private toastrService: ToastrService, private appComponent: AppComponent) {}

  ngOnInit() {
    this.authService.IsUserLoggedIn();
    this.CreateForgotPasswordForm();
    this.appComponent.setTitle('Forgot Password');
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('login-two');
    this.appName = environment.projectName;
    this.copyright = environment.copyright;
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-two');
  }

  CreateForgotPasswordForm() {
    this.forgotPasswordForm = this.fb.group({
      Email: ['', [Validators.required, Validators.email]],
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  forgotPassword() {
    if (this.forgotPasswordForm.valid) {
      this.model = Object.assign({}, this.forgotPasswordForm.value);
      this.authService.forgotPassword(this.model).subscribe(
        (next) => {
          this.forgotPasswordStatus = true;
        },
        (error) => {}
      );
    } else {
      this.validateAllFormFields(this.forgotPasswordForm);
    }
  }
}
